import React from 'react';

export default function FirstVoteModal({
  mode = 'onboarding',
  hasCrews = false,
  onDismiss,
  onStartVoting,
  onGoCreateTrial,
  onPrimaryAction,
}) {
  if (mode === 'next_step') {
    return (
      <div className="fixed inset-0 z-[9999] bg-slate-950/90 backdrop-blur-sm p-4 flex items-center justify-center">
        <div className="w-full max-w-xl rounded-2xl border border-slate-700 bg-slate-900 shadow-2xl p-6 sm:p-8">
          <div className="flex items-center justify-between mb-4">
            <div className="text-xs text-slate-400 font-semibold tracking-wide">Nice. Your first vote is in.</div>
            <button
              onClick={onDismiss}
              className="text-slate-400 hover:text-slate-200 text-sm font-semibold"
            >
              Close
            </button>
          </div>

          <div className="text-5xl mb-4">{hasCrews ? '👥' : '🔥'}</div>
          <h2 className="text-2xl font-black text-slate-50">
            {hasCrews ? 'Take it to your crews' : 'Start your own crew'}
          </h2>
          <p className="text-purple-300 font-semibold mt-1">Don’t stop at one vote.</p>
          <p className="text-slate-300 mt-4 leading-relaxed">
            {hasCrews
              ? 'Your crews are the fastest way to find better debates and weigh in where your opinion actually matters.'
              : 'Crews are the fastest way to get relevant votes from people who actually know the debate.'}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-2">
            <button
              onClick={onPrimaryAction}
              className="w-full rounded-xl bg-purple-600 hover:bg-purple-500 text-white font-bold py-3"
            >
              {hasCrews ? 'Open My Crews' : 'Create Crew'}
            </button>
            <button
              onClick={onGoCreateTrial}
              className="w-full rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-900 font-black py-3"
            >
              Create a Trial
            </button>
          </div>

          <button
            onClick={onDismiss}
            className="mt-3 w-full rounded-xl bg-slate-700 hover:bg-slate-600 text-slate-100 font-bold py-3"
          >
            Keep Browsing
          </button>
        </div>
      </div>
    );
  }

  const handleSkip = () => {
    onDismiss?.();
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-slate-950/90 backdrop-blur-sm p-4 flex items-center justify-center">
      <div className="w-full max-w-xl rounded-2xl border border-slate-700 bg-slate-900 shadow-2xl p-6 sm:p-8">
        <div className="flex items-center justify-between mb-4">
          <div className="text-xs text-slate-400 font-semibold tracking-wide">First move</div>
          <button
            onClick={handleSkip}
            className="text-slate-400 hover:text-slate-200 text-sm font-semibold"
          >
            Skip
          </button>
        </div>

        <div className="text-5xl mb-4">⚖️</div>
        <h2 className="text-2xl font-black text-slate-50">Vote on something now.</h2>
        <p className="text-purple-300 font-semibold mt-1">That is the fastest way to get GweffIT.</p>
        <p className="text-slate-300 mt-4 leading-relaxed">
          Cast one vote, leave, then come back when the verdict lands. That is the core loop.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-2">
          <button
            onClick={async () => {
              await onStartVoting?.();
              onDismiss?.();
            }}
            className="w-full rounded-xl bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3"
          >
            Vote Now
          </button>
          <button
            onClick={handleSkip}
            className="w-full rounded-xl bg-slate-700 hover:bg-slate-600 text-slate-100 font-bold py-3"
          >
            Browse First
          </button>
        </div>

        <div className="mt-3 text-xs text-slate-500">
          Creating your own trial can wait until after your first vote.
        </div>
      </div>
    </div>
  );
}
